export const DATE_TIME_FORMAT_SERVER = "YYYY-MM-DDTHH:mm:ss.SSSSS%2b00:00";
export const DATE_TIME_FORMAT_SERVER_POST = "YYYY-MM-DDTHH:mm:ss.SSSSS+00:00";
export const DATE_TIME_FORMAT_CLIENT = "DD/MM/YYYY";
export const DATE_TIME_FORMAT_CLIENT_V2 = "DD MMM YYYY";
export const TIME_FORMAT_CLIENT = "hh:mm A";
